import React, { useRef, useState } from "react";
import { Document, Page } from "react-pdf";
import uploadStyles from "./Styles/PDFAnnotationaStyles.module.scss";
import Draggable from "react-draggable";
import PdfModal from "../Components/PdfModal/PdfModal";
import { useDropzone } from "react-dropzone";
import { Button } from "@mui/material";
import html2canvas from "html2canvas";

const PdfForm = () => {
  const [numPages, setNumPages] = useState<any | []>(null);
  const [fields, setFields] = useState<any>([]);
  const [selectedFile, setSelectedFile] = React.useState<[] | any>([]);
  const formats: any = ["png", "jpeg", "jpg"];
  const maxSize = 10 * 1024 * 1024;
  const containerRef = useRef<any>(null);

  const onDrop = (acceptedFilestype: any) => {
    const files = acceptedFilestype.map((a: any) => a.path);
    let AllFiles: any = [...selectedFile, ...acceptedFilestype];

    function hasDuplicates(array: any) {
      const uniqueSet = new Set(array);
      return uniqueSet.size !== array.length;
    }

    const duplicates: any = hasDuplicates(AllFiles.map((a: any) => a.path));

    if (selectedFile) {
      setSelectedFile((prev: any) => [...prev, ...acceptedFilestype]);
    } else {
      setSelectedFile(acceptedFilestype);
    }
  };

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: formats,
    // disabled: selectedFile,
    multiple: true,
  });

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const addField = (type: any, x: any, y: any) => {
    setFields([...fields, { type, x, y }]);
    console.log(type, x, y);
  };
  const saveImage = () => {
    html2canvas(containerRef.current).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.download = "image_with_fields.png";
      link.href = imgData;
      link.click();
    });
  };

  return (
    <div className={uploadStyles.mainWrapper}>
      <div className={uploadStyles.sideBar}>
        <div className={uploadStyles.uploadAreaOuter}>
          <section className="container" style={{ width: "100%" }}>
            <div
              {...getRootProps()}
              className={uploadStyles.uploadArea}
              style={{
                border: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "flex", justifyContent: "center" }}>
                {/* <img src={featherUpload} /> */}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input {...getInputProps()} />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <p className={uploadStyles.uploadtext1}>
                    Select a file or drag and drop here
                  </p>
                  <p className={uploadStyles.uploadtext2}>
                    File size no more than 10MB
                  </p>
                </div>
              </div>
              <Button
                variant="outlined"
                sx={{
                  width: "max-content",
                  margin: "0px auto",
                  color: "#0F91D2",
                  textTransform: "none",
                  padding: "0px 30px",
                  borderColor: "#0F91D2",
                  "&:hover": {
                    borderColor: "#0F91D2",
                  },
                }}
              >
                Select File
              </Button>
            </div>
          </section>
        </div>

        <div>
          <Button
            variant="contained"
            onClick={() => addField("text", 100, 100)}
          >
            Add Text Field
          </Button>
        </div>
        <div>
          <Button
            variant="contained"
            onClick={() => addField("checkbox", 200, 200)}
          >
            Add Checkbox
          </Button>
        </div>
        <div>
          <Button variant="contained" onClick={saveImage}>
            Save Image
          </Button>
        </div>
      </div>
      <div className={uploadStyles.centerSection}>
        <div className={uploadStyles.imageSection}>
          {selectedFile.length > 0 && (
            <div>
              {selectedFile.map((a: any) => (
                <img
                  src={URL.createObjectURL(a)}
                  className={uploadStyles.image}
                />
              ))}
            </div>
          )}
        </div>

        {fields.map((field, index) => (
          <Draggable
            key={index}
            defaultPosition={{ x: field.x, y: field.y }}
            onStop={(e, data) => {
              // Update the coordinates of the field after dragging
              const updatedFields = [...fields];
              updatedFields[index].x = data.x;
              updatedFields[index].y = data.y;
              setFields(updatedFields);

              console.log("updatedFields", updatedFields);
            }}
          >
            <div style={{ position: "absolute", left: field.x, top: field.y }}>
              {field.type === "text" && <textarea style={{ resize: "both" }} />}
              {field.type === "checkbox" && <input type="checkbox" />}
              {/* Add other field types as needed */}
            </div>
          </Draggable>
        ))}
      </div>
      <div className={uploadStyles.rightSection}></div>
    </div>
  );
};

export default PdfForm;
